"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overrides = exports.ButtonWithLinkStyles = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _componentTheme = require("@clds/component-theme");
var _typography = require("@clds/typography");
var _dist = require("../../dist");
var _buttonTheme2 = require("../buttonTheme");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-extra-non-null-assertion */
const buttonOverride = {
  primary: {
    background: {
      color: _componentTheme.globalTheme.palette.primary
    }
  },
  secondary: {
    background: {
      color: _componentTheme.globalTheme.palette.brand.accentCoral
    },
    typography: {
      type: 'contrastInvert'
    }
  }
};
const themeOverride = theme => ({
  ...theme,
  components: {
    ...(theme === null || theme === void 0 ? void 0 : theme.components),
    ...(0, _componentTheme.overrideTheme)(_buttonTheme2.buttonTheme, {
      pill: buttonOverride
    })
  }
});
const ButtonWithLinkStyles = (0, _styledComponents.default)(_dist.Button).withConfig({
  displayName: "media-library-widget-demo__ButtonWithLinkStyles"
})([":visited{", "}"], props => {
  var _buttonTheme;
  const {
    size,
    shape,
    variant
  } = props;
  const typographyType = (_buttonTheme = _buttonTheme2.buttonTheme[shape]) === null || _buttonTheme === void 0 || (_buttonTheme = _buttonTheme[variant]) === null || _buttonTheme === void 0 || (_buttonTheme = _buttonTheme.typography) === null || _buttonTheme === void 0 ? void 0 : _buttonTheme.type(props);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const typographyStyle = (0, _typography.typographyMixin)(size, typographyType);
  return (0, _styledComponents.css)(["", ";"], typographyStyle);
});
exports.ButtonWithLinkStyles = ButtonWithLinkStyles;
const ButtonLink = props => /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
  theme: themeOverride
}, /*#__PURE__*/_react.default.createElement(ButtonWithLinkStyles, _extends({
  // Reason why spreading props: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/41316
  as: 'a'
}, props)));
const Button = props => /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
  theme: themeOverride
}, /*#__PURE__*/_react.default.createElement(ButtonWithLinkStyles, props));
const overrides = {
  Button,
  ButtonLink
};
exports.overrides = overrides;
//# sourceMappingURL=media-library-widget-demo.js.map